import UseCase from "./marketing/UseCase";

export default function UseCaseSales() {
  return (
    <UseCase
      path="/for/sales"
      seoTitle="NFC business cards for sales — WhoBrew"
      seoDescription="A digital business card for AEs, BDRs, and sales leaders. One link with your demo calendar, deck, case studies, and lead-capture form."
      eyebrow="For sales"
      headline="Hand out unlimited cards. Book demos faster."
      italicWord="faster"
      subhead="One card with your demo calendar, your latest deck, your case-study PDFs, and a lead-capture form. Replace the printed leave-behind. Replace the awkward slack-DM-me-your-deck moment."
      preview={{ name: "Sean Thomas", title: "Account Executive", handle: "seanthomas" }}
      linkExamples={[
        { label: "Book a demo" },
        { label: "Sales deck (PDF)" },
        { label: "Pricing one-pager" },
        { label: "Case studies" },
        { label: "Calendly" },
        { label: "LinkedIn" },
        { label: "Loom intro video" },
        { label: "Apple Wallet" },
      ]}
      features={[
        {
          title: "A demo calendar people actually book.",
          body: "Embed Calendly, Cal.com, or your team-round-robin link as the primary CTA on your card. Most prospects book within 24 hours of the visit.",
        },
        {
          title: "Always-current decks and case studies.",
          body: "Replace your latest deck PDF with one click. The card link stays the same; the document the prospect downloads is always the current version.",
        },
        {
          title: "Lead capture before the meeting.",
          body: "Prospects can drop their email and ask a question without ever needing to book a meeting. The lead lands in your CRM-ready export tagged by source.",
        },
      ]}
      steps={[
        {
          title: "Build the card with your demo link and deck.",
          body: "Drop in your Calendly, your latest deck, your two best case studies. Two minutes.",
        },
        {
          title: "Use it at events, in your email signature, on your laptop sticker.",
          body: "Order an NFC card for trade-show season. Print the QR for your laptop. Add the link to your email signature so every cold email sends them somewhere real.",
        },
        {
          title: "Track which conversations close.",
          body: "See which links got clicked before the meeting was booked. Use that to refine your follow-up sequence. Export to your CRM with one click.",
        },
      ]}
      faq={[
        {
          q: "Can I use this if my company hands out branded paper cards?",
          a: "Yes. Most reps use both. Hand the paper card to the people who want one; share your WhoBrew link for everyone who wants the deck, the calendar, or the case studies right now.",
        },
        {
          q: "Does it work with HubSpot, Salesforce, or Pipedrive?",
          a: "WhoBrew exports leads as CSV, ready to import into any CRM. Direct integrations with HubSpot, Salesforce, and Apollo are on the roadmap.",
        },
        {
          q: "Can I track which deals came from a card visit?",
          a: "Yes. Tag links by event or by campaign and see attribution in your Insights tab. Export the visit-and-click log alongside leads for full source-of-record tracking.",
        },
        {
          q: "What about field sales reps without good signal?",
          a: "The card needs an internet connection to render. In low-signal environments, the QR fallback still works once the recipient is on Wi-Fi. Most field reps add an offline business card as backup; WhoBrew handles the moments when both phones have signal, which is most of them.",
        },
        {
          q: "Is there a team plan with shared analytics?",
          a: "Yes. WhoBrew for Teams gives a sales manager an aggregated view of every rep's visit volume, top links, and lead capture. $3.99 per seat per month.",
        },
      ]}
    />
  );
}
